import React, { useState } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Grid,
    Button,
} from "@mui/material";
import {
    Business,
    Phone,
    Description,
    Send,
    Image,
    AccountCircle,
    Analytics,
} from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { WB_SX } from "../../ui/ux/uiTokens";

const WhatsappBusinessDashboard = () => {
    const navigate = useNavigate();

    const menuItems = [
        {
            title: "Business Accounts",
            description: "View and manage WhatsApp Business Accounts",
            icon: <Business sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/accounts",
            color: blue[500],
        },
        {
            title: "Phone Numbers",
            description: "Manage phone numbers under WABA",
            icon: <Phone sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/phone-numbers",
            color: blue[600],
        },
        {
            title: "Templates",
            description: "Create and manage message templates",
            icon: <Description sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/templates",
            color: blue[700],
        },
        {
            title: "Send Messages",
            description: "Send template, text, or media messages",
            icon: <Send sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/send-message",
            color: blue[800],
        },
        {
            title: "Media Management",
            description: "Upload, view, and download media files",
            icon: <Image sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/media",
            color: blue[900],
        },
        {
            title: "Business Profile",
            description: "View and update business profile information",
            icon: <AccountCircle sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/profile",
            color: blue[400],
        },
        {
            title: "Messaging Limits",
            description: "View messaging limits and analytics",
            icon: <Analytics sx={{ fontSize: 40 }} />,
            path: "/whatsapp-business/limits",
            color: blue[300],
        },
    ];

    return (
        <Box sx={WB_SX.page}>
            <Typography
                variant="h6"
                sx={WB_SX.pageTitle}
            >
                WhatsApp Business Dashboard
            </Typography>

            <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            elevation={0}
                            sx={{
                                height: "100%",
                                cursor: "pointer",
                                ...WB_SX.card,
                                transition: "border-color 0.15s, box-shadow 0.15s",
                                "&:hover": {
                                    borderColor: item.color,
                                    boxShadow: "0 8px 24px rgba(17,24,39,0.08)",
                                },
                            }}
                            onClick={() => navigate(item.path)}
                        >
                            <CardContent>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        p: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 64,
                                            height: 64,
                                            borderRadius: 2,
                                            display: "grid",
                                            placeItems: "center",
                                            color: item.color,
                                            backgroundColor: `${item.color}18`,
                                            mb: 2,
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Typography
                                        variant="h6"
                                        sx={{ mb: 1, fontWeight: "bold" }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mb: 2 }}
                                    >
                                        {item.description}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            ...WB_SX.primaryButton,
                                            backgroundColor: item.color,
                                            "&:hover": {
                                                backgroundColor: item.color,
                                                opacity: 0.9,
                                            },
                                        }}
                                    >
                                        Open
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default WhatsappBusinessDashboard;

